/** @jsx h */
import { h } from "hyperapp";
import classNames from "classnames";
import { playerEvents, queueEvents } from "../events";
import { PlayableDefault, PlayableQueue, PlayableStreams } from "../playables";
import Advertisement from "../components/advertisement";
import Recommended from "../components/recommended";
import Player from "../components/player";
import Queue from "../components/queue";
import Streams from "../components/streams";
import bus from "../../bus";
import { connect, WrappedSvg } from "../../utilities/hyperapp";
import { historyProgressEvents } from "../../history-progress";

import closeIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../../masthead/close.svg";

let currentPlayable;
let prevType;

function playableTargetSelector(state, actions) {
  // TODO this is messy af, can we clean up the attributes we send to each type?
  // or at least normalise it in this function?
  const payload = { state, actions };
  switch (state.player.target.type) {
    case "queue":
      if (prevType !== state.player.target.type) {
        currentPlayable = null;
        currentPlayable = new PlayableQueue(payload);
      } else {
        currentPlayable.set(payload);
      }
      break;
    case "stream":
      if (prevType !== state.player.target.type) {
        currentPlayable = null;
        currentPlayable = new PlayableStreams(payload);
      } else {
        currentPlayable.set(payload);
      }
      break;
    default:
      currentPlayable = null;
      currentPlayable = new PlayableDefault(payload);
      break;
  }
  prevType = state.player.target.type;
  return currentPlayable;
}

const mapToProps = (state, actions, props) => {
  return {
    playableTarget: playableTargetSelector(state, actions)
  };
};

function closeOnMobile() {
  const isMobile = document.documentElement.classList.contains(
    "breakpoint-is-mobile"
  );
  if (isMobile) {
    bus.emit(playerEvents.CLOSE);
  }
}

const Wrapper = connect(mapToProps)(({ state, actions, playableTarget }) => {
  const {
    activated,
    activeTab,
    player,
    queue,
    streams,
    recommended,
    advertisement
  } = state;

  // TODO: These should really be actions though it doesn’t matter much because the
  // player is never recreated
  function onCreate() {
    actions.init();
    bus.on(historyProgressEvents.ACTIVATE, closeOnMobile);
    bus.on(playerEvents.OPEN, actions.open);
    bus.on(playerEvents.CLOSE, actions.close);
    bus.on(queueEvents.RESOLVE, actions.tick);
  }

  function onUpdate(el) {
    const panel = el.parentNode;
    const action = state.open ? "add" : "remove";
    panel.classList[action]("player-panel--active");
    document.documentElement.classList[action]("with-player");
  }

  return (
    <div
      oncreate={onCreate}
      onupdate={onUpdate}
      class={classNames({
        "player-panel__inner": true
      })}
    >
      <button
        class="player-panel__close"
        aria-label="Close player"
        onclick={e => {
          e.preventDefault();
          actions.close();
        }}
      >
        <span>
          <WrappedSvg data={closeIcon} />
        </span>
      </button>
      <Streams
        isPlayerTarget={
          state.player.target && state.player.target.type === "stream"
        }
        availableStreams={streams.available}
        playerStatus={player.status}
        playerTarget={playableTarget}
      />
      <Advertisement advertisement={advertisement} />
      <Player
        isOpen={state.open}
        muted={player.muted}
        status={player.status}
        target={playableTarget}
        volume={player.volume}
        quality={player.quality}
        currentTargetType={
          state.player.target && state.player.target.type
            ? state.player.target.type
            : null
        }
        currentItemPlayerItemID={
          playableTarget && playableTarget.currentItem()
            ? playableTarget.currentItem().getPlayerItemID()
            : null
        }
        currentItemTitle={
          playableTarget && playableTarget.currentItem()
            ? playableTarget.currentItem().getTitle()
            : null
        }
        currentItemSubtitle={
          playableTarget && playableTarget.currentItem()
            ? playableTarget.currentItem().getSubtitle()
            : null
        }
        currentItemLive={
          playableTarget && playableTarget.currentItem()
            ? playableTarget.currentItem().isLive()
            : true
        }
        currentItemReady={
          playableTarget && playableTarget.currentItem()
            ? playableTarget.currentItem().isReady()
            : true
        }
        set={actions.player.set}
        activate={actions.activate}
        availableStreams={streams.available}
      />
      <div>
        <span class="player-tabs-heading mb-xsmall d-block t-center c-white caps-heading">
          On Demand
        </span>
        <ul class="player-tabs mb-small">
          <li
            class={classNames("player-tabs__item", {
              "player-tabs__item--selected": activeTab === "queue"
            })}
          >
            <button
              onclick={e => {
                e.preventDefault();
                actions.setActiveTab("queue");
              }}
            >
              Your queue
            </button>
          </li>
          <li
            class={classNames("player-tabs__item", {
              "player-tabs__item--selected": activeTab === "recommended"
            })}
          >
            <button
              onclick={e => {
                e.preventDefault();
                actions.setActiveTab("recommended");
              }}
            >
              RRR Recommends
            </button>
          </li>
        </ul>
        <Recommended
          visible={activeTab === "recommended"}
          items={recommended.items}
          currentItemPlayerItemID={
            playableTarget && playableTarget.currentItem()
              ? playableTarget.currentItem().getPlayerItemID()
              : null
          }
        />
        <Queue
          visible={activeTab === "queue"}
          isPlayerTarget={
            state.player.target && state.player.target.type === "queue"
          }
          currentItem={queue.currentItem}
          playedItems={queue.playedItems}
          upcomingItems={queue.upcomingItems}
          setCurrentItem={actions.queue.setCurrent}
          removeItem={actions.queue.remove}
          appendItems={actions.queue.append}
          prependItems={actions.queue.prepend}
          moveTo={actions.queue.moveTo}
          reorder={actions.queue.reorder}
          updateOrder={actions.queue.updateOrder}
          fetch={actions.queue.fetch}
          playerOpen={state.open}
          clear={actions.queue.clear}
          activated={activated}
        />
      </div>
    </div>
  );
});

export default (state, actions) => <Wrapper state={state} actions={actions} />;
